import Router from 'vue-router';
import SignIn from '@/views/application/SignIn.vue';
import SignOut from '@/views/application/SignOut.vue';
import LogViewer from '@/views/log-viewer/LogViewer.vue';
import Users from '@/views/users/Users.vue';
import Vue from 'vue';
import store from './store';
import Info from '@/views/info/Info.vue';
import {UserRoleWithPrefix} from "@/components/users/model/UserRoleWithPrefix";
import LicenseView from "@/views/license/LicenseView";

Vue.use(Router);

/**
 * Router definition (URL to component mapping)
 *
 * To use frontend auth, use router meta param:
 * meta: { requiresAuth: ['ADMIN', 'USER'] }
 *
 * To define a loginpage, use:
 * meta: { loginPage: true }
 */
const router = new Router({
  linkExactActiveClass: 'current-menu-item',
  routes: [{
    path: '/',
    name: 'Home',
    component: LicenseView,
    meta: {
      requiresAuth: [
        UserRoleWithPrefix.ROLE_ADMIN]
    }
  },
    {
      path: '/application/signin',
      name: 'signIn',
      component: SignIn,
      meta: {
        loginPage: true,
      },
    },
    {
      path: '/application/signout',
      name: 'signOut',
      component: SignOut,
    },
    {
      path: '/users',
      name: 'users',
      component: Users,
    },
    {
      path: '/log-viewer',
      name: 'logViewer',
      component: LogViewer,
      meta: {
        requiresAuth: [
          UserRoleWithPrefix.ROLE_ADMIN]
      }
    },
    {
      path: '/info',
      name: 'info',
      component: Info,
    },
    {
      path: '/clients',
      name: 'client',
      component: LicenseView,
      meta: {
        requiresAuth: [
          UserRoleWithPrefix.ROLE_ADMIN]
      }
    },
  ],
});
// Before following routes, check authentication
router.beforeEach((to, from, next) => {
  const isLoginPage = to.matched.some((record) => record.meta.loginPage);

  const isDevelopmentFeature = to.matched.find((r) => r.meta && r.meta.developmentFeature);
  // We disable routing to development features if production profile is active
  if (isDevelopmentFeature && store.state.productionProfileActive) {
    return;
  }

  // Check if meta requiresAuth is set
  const routeRequiresAuth = to.matched.find((r) => r.meta && r.meta.requiresAuth);
  let requiresAuth: string[] = [];
  if (routeRequiresAuth) {
    // The found route requires authentication. Fetch meta.RequiresRole from it.
    requiresAuth = routeRequiresAuth.meta.requiresAuth;
  }
  // Retrieve potential user from local storage
  const lsUser = localStorage.getItem('authUser');
  const authUser = lsUser ? JSON.parse(lsUser) : null;

  if (routeRequiresAuth) {
    // This route requires authorization
    if (!authUser) {
      // There's no user signed in, route to signin page
      store.commit('setError', 'auth.error.noAuthSignedIn');
      next('/application/signIn');
    } else if (authUser.authorities.some((r: string) => requiresAuth.includes(r))) {
      // User has the right authorities, continue to follow the route
      next();
    } else {
      // User doesn't have the right authorities, logout the current user to force a new login
      store.dispatch('userSignOut', {error: 'auth.error.notAuthorized'});
      router.push('/application/signIn');
    }
  } else if (isLoginPage && authUser) {
    // Already logged in, route to home
    router.push('/');
  } else {
    // No auth required follow the chosen route
    next();
  }

});
export default router;
